import React from 'react';
import { AlertCircle } from 'lucide-react';

const ErrorMessage = ({ message, onRetry }) => {
  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md w-full">
        <div className="flex items-start">
          <AlertCircle className="h-6 w-6 text-red-600 mr-3 flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <h3 className="text-sm font-medium text-red-800 mb-1">
              Erro
            </h3>
            <p className="text-sm text-red-700">
              {message || 'Ocorreu um erro inesperado. Por favor, tente novamente.'}
            </p>
            {onRetry && (
              <button
                onClick={onRetry}
                className="mt-4 text-sm font-medium text-red-800 hover:text-red-900 underline"
              >
                Tentar novamente
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;

